export const FETCH_NOTIFICATIONS_PENDING = 'FETCH_NOTIFICATIONS_PENDING';
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const FETCH_NOTIFICATION_PENDING = 'FETCH_NOTIFICATION_PENDING';
export const FETCH_NOTIFICATION = 'FETCH_NOTIFICATION';
export const FETCH_NOTIFICATION_TYPES_PENDING = 'FETCH_NOTIFICATION_TYPES_PENDING';
export const FETCH_NOTIFICATION_TYPES = 'FETCH_NOTIFICATION_TYPES';
export const FETCH_NOTIFICATION_USER_GROUPS_PENDING = 'FETCH_NOTIFICATION_USER_GROUPS_PENDING';
export const FETCH_NOTIFICATION_USER_GROUPS = 'FETCH_NOTIFICATION_USER_GROUPS';
